import { downloadCsv } from "../../../../utils/csvExport.js";
import { csvField, filenameStamp } from "./csvHelpers.js";
import type { FamilyConflict } from "./findFamilyConflicts.js";
import type { MoveToSetRunResult } from "./useMoveToSetBatch.js";

export const RESULTS_HEADERS = [
  "testimonial_id",
  "row_kind",
  "requested_id",
  "testimonial_type",
  "outcome",
  "previous_contact_id",
  "previous_testimonial_type",
  "error",
] as const;

export function buildResultsCsv(results: MoveToSetRunResult[]): string {
  const lines: string[] = [RESULTS_HEADERS.join(",")];
  for (const result of results) {
    lines.push(
      [
        result.id,
        result.rowKind,
        result.requestedId,
        result.testimonialType,
        result.outcome,
        result.previousContactId,
        result.previousTestimonialType,
        result.error ?? null,
      ]
        .map(csvField)
        .join(","),
    );
  }
  return `${lines.join("\n")}\n`;
}

export function resultsFilename(dryRun: boolean, now: Date): string {
  return `move-to-set-${dryRun ? "dry-run" : "applied"}-${filenameStamp(now)}.csv`;
}

export function downloadResultsCsv(results: MoveToSetRunResult[], dryRun: boolean, at: Date): void {
  downloadCsv(buildResultsCsv(results), resultsFilename(dryRun, at));
}

export const CONFLICTS_HEADERS = ["mate_id", "requested_id", "severity", "reason"] as const;

export function buildConflictsCsv(conflicts: FamilyConflict[]): string {
  const lines: string[] = [CONFLICTS_HEADERS.join(",")];
  for (const { mateId, requestedId, severity, reason } of conflicts) {
    lines.push([mateId, requestedId, severity, reason].map(csvField).join(","));
  }
  return `${lines.join("\n")}\n`;
}

export function downloadConflictsCsv(conflicts: FamilyConflict[], at: Date): void {
  downloadCsv(
    buildConflictsCsv(conflicts),
    `move-to-set-family-conflicts-${filenameStamp(at)}.csv`,
  );
}
